import { render, staticRenderFns } from "./home_ASM_RSM.vue?vue&type=template&id=206f239d&scoped=true"
import script from "./home_ASM_RSM.vue?vue&type=script&lang=js"
export * from "./home_ASM_RSM.vue?vue&type=script&lang=js"
import style0 from "./home_ASM_RSM.vue?vue&type=style&index=0&id=206f239d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f239d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206f239d')) {
      api.createRecord('206f239d', component.options)
    } else {
      api.reload('206f239d', component.options)
    }
    module.hot.accept("./home_ASM_RSM.vue?vue&type=template&id=206f239d&scoped=true", function () {
      api.rerender('206f239d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/home_ASM_RSM.vue"
export default component.exports